import { makeStyles } from 'tss-react/mui';
import React from 'react';
import PButton, { PrimaryButtonProps } from '@ui/Button/legacy/PrimaryButton';

interface OverlayButtonProps extends PrimaryButtonProps {}

const useStyles = makeStyles()(theme => ({
  overlay: {
    backgroundColor: 'rgba(255, 255, 255, 0.11)',
    color: theme.palette.common.white,
    '&:hover, &.Mui-focusVisible': {
      backgroundColor: 'rgba(255, 255, 255, 0.15)',
      boxShadow: 'none',
    },
    '&.Mui-disabled, &.Mui-disabled:hover': {
      backgroundColor: 'rgba(255, 255, 255, 0.08)',
      opacity: 0.6,
      color: 'white',
      pointerEvents: 'auto',
      cursor: 'not-allowed',
    },
  },
}));

const OverlayButton = React.forwardRef<HTMLButtonElement, OverlayButtonProps>(
  ({ children, ...props }, ref) => {
    const { classes } = useStyles();
    return (
      <PButton
        className={classes.overlay}
        variant="contained"
        {...props}
        ref={ref}
      >
        {children}
      </PButton>
    );
  }
);

export default OverlayButton;
